import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { fragmentsPermissions } from '@mi-front/api-clients';
import { Box } from '@mui/material';
import { SwitchElement } from 'react-hook-form-mui';
import { FormattedMessage } from 'react-intl';

export function ExportControl() {
  return (
    <IfPermission permission={fragmentsPermissions.Fragments_Delivery}>
      <Box>
        <SwitchElement
          name="doExternalExport"
          label={
            <FormattedMessage
              id="jointFragments.form.externalExport.allowedLabel"
              defaultMessage="Export externo"
            />
          }
          switchProps={{
            size: 'small',
          }}
        />
      </Box>
    </IfPermission>
  );
}
